export const EVENTS_SCHEMA_VERSION = "0.54.0";
export const PAGE_VIEWS_SCHEMA_VERSION = "0.26.0";
